<template>
  <div class="container how_it_work_block">
    <div class="how_it_work_block__row">
      <div
        v-for="(block, index) in blocks"
        class="how_it_work_block-item">
        <div class="position-relative">
          <svg
            class="how_it_work_block-arrow"
            width="100%"
            height="16" viewBox="0 0 231 16" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M230.707 8.70711C231.098 8.31658 231.098 7.68342 230.707 7.29289L224.343 0.928933C223.953 0.538408 223.319 0.538408 222.929 0.928933C222.538 1.31946 222.538 1.95262 222.929 2.34315L228.586 8L222.929 13.6569C222.538 14.0474 222.538 14.6805 222.929 15.0711C223.319 15.4616 223.953 15.4616 224.343 15.0711L230.707 8.70711ZM-0.00390625 9H230V7H-0.00390625V9Z"
            />
          </svg>
          <div class="how_it_work_block-counter position-relative">
            {{ index + 1 }}
          </div>
        </div>
        <html-block
          class="mt-15"
          :content="block.content"
        />
      </div>
    </div>
  </div>
</template>

<script>

import HtmlBlock from "../small_parts/HtmlBlock.vue";

export default {
  name: "HowItWorkBlock",
  components: {HtmlBlock},
  props: {
    /**props**/
    blocks: {
      type: Array,
      default: () => [],
      admin_type: 'array',
      array_values: {
        content: {
          type: String,
          required: '',
          admin_type: 'editor',
        },
      }
    }
    /**props**/
  },
}
</script>
